import { AlertDialog } from '../shared/components/alert-dialog';
import { Page, type PageProps } from '../shared/ui/page/page';
import { GlobalTopRightContent } from './GlobalTopRightContent';

function DashboardPage({ children, topRight, ...props }: PageProps) {
  return (
    <Page
      {...props}
      topRight={<GlobalTopRightContent>{topRight}</GlobalTopRightContent>}
    >
      <AlertDialog
        alertType="actionless"
        headerText=""
        bodyContent={<span></span>}
        buttonLoading={false}
        showCloseBtn={false}
      />
      {children}
    </Page>
  );
}

export default DashboardPage;
